import React, { useRef, useEffect, useState, useCallback } from "react";

import Tooltip from "@mui/material/Tooltip";

/* This tooltip component will only trigger when there is any overflow text and dev want to show entire text in tooltip, 
other text which are not overflowing, there will no tooltip will be show */

const OverflowTip = ({ children, ...props }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const textElementRef = useRef(null);

  const compareSize = useCallback(() => {
    setShowTooltip(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
  }, []);

  useEffect(() => {
    compareSize();
  }, [children, compareSize]);

  useEffect(() => {
    window.addEventListener("resize", compareSize);

    // remove resize listener again on "componentWillUnmount"
    return () => {
      window.removeEventListener("resize", compareSize);
    };
  }, [compareSize]);

  return showTooltip ? (
    <Tooltip {...props}>
      {React.cloneElement(children, {
        ref: (ref) => (textElementRef.current = ref),
        style: { cursor: "pointer" },
      })}
    </Tooltip>
  ) : (
    React.cloneElement(children, {
      ref: (ref) => (textElementRef.current = ref),
    })
  );
};

export default React.memo(OverflowTip);
